// extracted by mini-css-extract-plugin
export default {"need_hand_child":"NeedHandChild_need_hand_child__m45lB"};